import { gql } from 'graphql-request';

import {
  ItemTypeCreatedAt,
  ItemTypeDescription,
  ItemTypeID,
  ItemTypeImageUrl,
  ItemTypeName,
  ItemTypeNanoID,
  ItemTypeNewClientDefaultAt,
  ItemTypePrice,
  ItemTypeUpdatedAt,
  ItemTypeUUID,
  ItemTypeViewPrice,
  ItemTypeViewPriceCurrency
} from '../itemTypesTypes';
import {
  ItemCategoryID,
  ItemCategoryName,
  ItemCategoryNanoID
} from '../../itemCategories/itemCategoriesTypes';
import { TeamName, TeamNanoID } from '../../teams/teamsTypes';
import { ID, MayBe } from '../../../types';
import {
  ItemTagID,
  ItemTagName,
  ItemTagPosition
} from '../../itemTags/itemTagsTypes';

export interface FetchCacheItemTypesQueryResponse {
  id: ItemTypeID;
  uuid: ItemTypeUUID;
  nanoId: ItemTypeNanoID;
  createdAt: ItemTypeCreatedAt;
  updatedAt: ItemTypeUpdatedAt;
  name: ItemTypeName;
  description: ItemTypeDescription;
  newClientDefaultAt: ItemTypeNewClientDefaultAt;
  imageUrl: ItemTypeImageUrl;
  price: ItemTypePrice;
  viewPrice: ItemTypeViewPrice;
  viewPriceCurrency: ItemTypeViewPriceCurrency;
  itemCategory: {
    id: ItemCategoryID;
    name: ItemCategoryName;
    nanoId: ItemCategoryNanoID;
  } | null;
  company: MayBe<{
    nanoId: TeamNanoID;
    name: TeamName;
  }>;
  itemTypeItemTags: {
    id: ID;
    itemTag: {
      id: ItemTagID;
      name: ItemTagName;
    };
    position: ItemTagPosition;
  }[];
}

export const FETCH_CACHE_ITEM_TYPES_QUERY = gql`
  query CacheItemTypes(
    $filters: ItemTypesFilters
    $sort: [ItemTypesSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    itemTypes(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        nanoId
        createdAt
        updatedAt
        name
        description
        newClientDefaultAt
        imageUrl
        price
        viewPrice
        viewPriceCurrency
        itemCategory {
          id
          name
          nanoId
        }
        company {
          nanoId
          name
        }
        itemTypeItemTags {
          id
          itemTag {
            id
            name
          }
          position
        }
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
